var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncrease16To30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5521 9.29876C44.988 9.8144 44.1125 9.77287 43.5968 9.20879L39.9978 5.26715V30.6681C39.9978 31.6232 39.2226 32.3984 38.2675 32.3984H19.3068C18.3516 32.3984 17.5765 31.6232 17.5765 30.6681V19.7221H3.46062V36.1808C3.46062 37.136 2.68544 37.9111 1.73031 37.9111C0.775178 37.9111 0 37.136 0 36.1808V17.9918C0 17.0367 0.775178 16.2615 1.73031 16.2615H19.3068C20.2619 16.2615 21.0371 17.0367 21.0371 17.9918V28.9378H36.5406V4.9903L32.2599 9.05652C31.7062 9.58253 30.8306 9.56177 30.3011 9.00807C29.7751 8.45437 29.7959 7.57884 30.3496 7.05282L36.686 1.03135C36.9559 0.422283 37.5615 8.7738e-05 38.2675 8.7738e-05C38.2813 8.7738e-05 38.2917 8.7738e-05 38.3021 0.00354767C38.309 0.00354767 38.3159 0.00354767 38.3229 0.00354767C38.4163 0.00354767 38.5097 0.0139313 38.5997 0.0312347C38.6274 0.0381546 38.6551 0.0485382 38.6828 0.0554581C38.7451 0.0727615 38.8073 0.0866051 38.8662 0.114288C39.278 0.266556 39.6137 0.571095 39.8075 0.962143L45.6386 7.34698C46.1542 7.91106 46.1127 8.78659 45.5486 9.30223L45.5521 9.29876Z",
    fill: "#F3A890"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease16To30);
export default __webpack_public_path__ + "static/media/increase16to30.edd6b9eb2d7750fa57ae61aff0f9bfff.svg";
export { ForwardRef as ReactComponent };